import axios from "axios";
import { ElLoading, ElMessageBox } from "element-plus";
import { locale } from "../js/sakura";
import router from "../router";
import { useWebSocketStore } from '@/stores/websocket';
let alert = '';

// ✅ Global loading controller
export class LoadingController {
  count = 0;
  loadingInstance = null;

  start() {
    this.count++;
    if (this.count === 1) {
      this.loadingInstance = ElLoading.service({ fullscreen: true });
    }
  }

  stop() {
    this.count--;
    if (this.count <= 0 && this.loadingInstance) {
      this.loadingInstance.close();
      this.loadingInstance = null;
      this.count = 0;
    }
  }
  reset() {
    if (this.loadingInstance) {
      this.loadingInstance.close();
      this.loadingInstance = null;
    }
    this.count = 0;
  }
}

const GlobalLoader = new LoadingController();

// ✅ Create Axios instance
const Fetch = axios.create({
  baseURL: window.base || "",
  timeout: 60000 * 3,
  headers: {
    'Accept': 'application/json, text/plain, */*',
    'Cache-Control': 'no-cache',
    'Pragma': 'no-cache'
  }
});

// ✅ Request Interceptor
Fetch.interceptors.request.use(
  (config) => {
    // ⏳ Start loader if not disabled manually
    if (config.loading !== false) {
      GlobalLoader.start();
    }

    const sessionToken = sessionStorage.getItem('token');
    if (sessionToken) {
      config.headers['Session'] = sessionToken;
    }

    return config;
  },
  (error) => {
    GlobalLoader.stop();
    return Promise.reject(error);
  }
);

// ✅ Response Interceptor
Fetch.interceptors.response.use(
  (response) => {
    GlobalLoader.stop();
    if (response.config.responseType === 'blob') {
      return response;
    }
    return response.data;
  },
  (error) => {
    GlobalLoader.stop();
    if (error.response && error.response.status === 403) {
      if (!alert) {
        const wsStore = useWebSocketStore();
        wsStore.stopIdleTracking();
        message(router, locale.global.logout.message);
      } 
      // console.warn("Unauthorized access - Redirecting to login");
      // router.push("/login");
    }
    return Promise.reject(error);
  }
);

function message(router, msg) {
  alert = ElMessageBox.alert(msg, locale.global.logout.title, {
    type: 'warning',
    customClass: 'message-box-on-top commonalert',
    appendTo: document.body,
    showClose: false, callback: action => {
      router.push("/login");
      alert = '';
    }
  });
}

export default Fetch;
export { GlobalLoader };
